import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-[5%]" }
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = { class: "w-full bg-gray-400 p-2" }
const _hoisted_4 = { class: "text-lg font-semibold" }
const _hoisted_5 = { class: "flex gap-4" }
const _hoisted_6 = { class: "flex gap-4" }
const _hoisted_7 = { class: "w-full bg-gray-400 p-2" }
const _hoisted_8 = { class: "text-lg font-semibold" }
const _hoisted_9 = { class: "flex gap-4" }
const _hoisted_10 = { class: "w-full bg-gray-400 p-2" }
const _hoisted_11 = { class: "text-lg font-semibold" }
const _hoisted_12 = { class: "flex gap-4 mt-2" }
const _hoisted_13 = { class: "space-y-0.5" }
const _hoisted_14 = { class: "w-full bg-gray-400 p-2 mb-2" }
const _hoisted_15 = { class: "text-lg font-semibold" }
const _hoisted_16 = { class: "flex w-full gap-4" }
const _hoisted_17 = { class: "w-full bg-gray-400 p-2 mb-2" }
const _hoisted_18 = { class: "text-lg font-semibold" }
const _hoisted_19 = { class: "flex w-full gap-4" }

import {Check, ChevronsUpDown, ImagePlus, Image, File, FilePlus} from "lucide-vue-next";
  import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
  import {Separator} from "@/components/ui/separator";
  import {Button} from "@/components/ui/button";
  import {Switch} from "@/components/ui/switch";
  import {Input} from "@/components/ui/input";
  import {Textarea} from "@/components/ui/textarea";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";
  import {
    Popover,
    PopoverContent,
    PopoverTrigger,
  } from '@/components/ui/popover'
  import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
  } from '@/components/ui/command'
  import TablesService from "@/services/tables/tables.service";
  import {onMounted, ref, watch} from "vue";
  import {i18n} from "@/utils/i18n";
  import {cn, toast} from "@/utils/utils";
  import router from "@/router";
  import {useRoofStore} from "@/store/roof.store";
  import UploadDocumentDialog from "@/components/building/UploadDocumentDialog.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingForm',
  props: {
    id: {},
    entity: {}
  },
  emits: ['enableRoofs'],
  setup(__props: any, { emit: __emit }) {

  const props = __props
  const emit = __emit
  let building: any = {};
  let managers: any = [];
  let masters: any = [];
  const roofStore = useRoofStore();
  const mastersOpen = ref(false);
  const managersOpen = ref(false);
  const isDocumentDialogOpen = ref(false);

  const buildingSchema = toTypedSchema(z.object({
    name: z.string(),
    code: z.string(),
    address: z.string(),
    city: z.string(),
    zip: z.string(),
    province: z.string(),
    state: z.string(),
    yearConstruction: z.number(),
    activity: z.string(),
    description: z.string(),
    master: z.number(),
    manager: z.number(),
    enabled: z.boolean().default(true)
  }))

  const { handleSubmit, values, setValues } = useForm({
    validationSchema: buildingSchema
  })

  watch(values, (newFormData) => {
    building = newFormData;
  });

  async function getManagers() {
    const res = await TablesService.getData('managers')
    managers = res?.data
  }

  async function getMasters() {
    const res = await TablesService.getData('masters')
    masters = res?.data
  }

  const setIsDocumentDialogOpen = (value: boolean) => {
    isDocumentDialogOpen.value = value;
  };

  const onSubmitBuilding = handleSubmit(async () => {
    let res;
    if (props.id === '0') {
      res = await TablesService.createRecord(building, props.entity);
      if (res?.data.id) {
        emit('enableRoofs', res.data.id);
        await router.push({name: 'newBuilding', params: {id: res.data.id}});
        await initializeForm();
        toast.success(i18n.global.t('toast.insert_success'));
      }
    } else {
      res = await TablesService.updateRecord(building, props.entity);
      if (res?.data) {
        toast.success(i18n.global.t('toast.edit_success'));
      }
    }
  })

  onMounted(async () => {
    await getManagers();
    await getMasters();
    if (props.id !== '0') {
      await initializeForm();
    }
  })

  async function initializeForm() {
    const res = await TablesService.getElementById(props.entity, props.id);
    if (res?.data) {
      res.data.manager = res.data.manager?.id;
      res.data.master = res.data.master?.id;
      setValues(res.data);
      await roofStore.setRoofList(res.data.roofings);
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmitBuilding) && _unref(onSubmitBuilding)(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(FormField), { name: "name" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.name')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.name'),
                      type: "text",
                      "auto-correct": "off"
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_unref(FormField), { name: "code" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.code')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.code'),
                      type: "text",
                      "auto-correct": "off"
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(Separator), { class: "mt-3" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('building.location')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(FormField), { name: "address" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.address')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.address'),
                      type: "text",
                      "auto-correct": "off"
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_unref(FormField), { name: "city" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.city')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.city'),
                      type: "text",
                      "auto-correct": "off"
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(FormField), { name: "zip" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.zip')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.zip'),
                      type: "text",
                      "auto-correct": "off"
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_unref(FormField), { name: "province" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.province')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.province'),
                      type: "text",
                      "auto-correct": "off"
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_unref(FormField), { name: "state" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.state')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.state'),
                      type: "text",
                      "auto-correct": "off"
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(Separator), { class: "mt-3" }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('building.generality')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(FormField), { name: "yearConstruction" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.yearConstruction')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.yearConstruction'),
                      type: "number",
                      "auto-correct": "off"
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_unref(FormField), { name: "activity" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.activity')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.activity'),
                      type: "text",
                      "auto-correct": "off"
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(FormField), { name: "description" }, {
          default: _withCtx(({ componentField }) => [
            _createVNode(_unref(FormItem), { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.description')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormControl), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Textarea), _mergeProps(componentField, {
                      placeholder: _ctx.$t('column.description')
                    }), null, 16, ["placeholder"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(FormMessage))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(Separator), { class: "mt-3" }),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('building.master_and_manager')), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(FormField), { name: "master" }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormItem), { class: "flex flex-col w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.master')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Popover), {
                  open: mastersOpen.value,
                  "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((mastersOpen).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Button), {
                              variant: "outline",
                              role: "combobox",
                              class: _normalizeClass(_unref(cn)('w-full justify-between', !_unref(values).master && 'text-muted-foreground'))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(values).master ? _unref(masters).find(
                        (master) => master.id === _unref(values).master,
                    )?.name : _unref(i18n).global.t('table.select')) + " ", 1),
                                _createVNode(_unref(ChevronsUpDown), { class: "ml-2 h-4 w-4 shrink-0 opacity-50" })
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(PopoverContent), { class: "w-[45vw] p-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Command), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CommandInput), {
                              placeholder: _ctx.$t('table.search')
                            }, null, 8, ["placeholder"]),
                            _createVNode(_unref(CommandEmpty), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('table.no_result')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(CommandList), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CommandGroup), null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(masters), (master) => {
                                      return (_openBlock(), _createBlock(_unref(CommandItem), {
                                        key: master.id,
                                        value: master.id,
                                        onSelect: () => {
                              _unref(setValues)({
                                master: master.id,
                              })
                              mastersOpen.value = false
                            }
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Check), {
                                            class: _normalizeClass(_unref(cn)('mr-2 h-4 w-4', master.id === _unref(values).master ? 'opacity-100' : 'opacity-0'))
                                          }, null, 8, ["class"]),
                                          _createTextVNode(" " + _toDisplayString(master.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "onSelect"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["open"]),
                _createVNode(_unref(FormMessage))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(FormField), { name: "manager" }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormItem), { class: "flex flex-col w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.manager')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Popover), {
                  open: managersOpen.value,
                  "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((managersOpen).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Button), {
                              variant: "outline",
                              role: "combobox",
                              class: _normalizeClass(_unref(cn)('w-full justify-between', !_unref(values).manager && 'text-muted-foreground'))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(values).manager ? _unref(managers).find(
                        (manager) => manager.id === _unref(values).manager,
                    )?.name : _unref(i18n).global.t('table.select')) + " ", 1),
                                _createVNode(_unref(ChevronsUpDown), { class: "ml-2 h-4 w-4 shrink-0 opacity-50" })
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(PopoverContent), { class: "w-[45vw] p-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Command), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CommandInput), {
                              placeholder: _ctx.$t('table.search')
                            }, null, 8, ["placeholder"]),
                            _createVNode(_unref(CommandEmpty), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('table.no_result')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(CommandList), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CommandGroup), null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(managers), (manager) => {
                                      return (_openBlock(), _createBlock(_unref(CommandItem), {
                                        key: manager.id,
                                        value: manager.id,
                                        onSelect: () => {
                              _unref(setValues)({
                                manager: manager.id,
                              })
                              managersOpen.value = false
                            }
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Check), {
                                            class: _normalizeClass(_unref(cn)('mr-2 h-4 w-4', manager.id === _unref(values).manager ? 'opacity-100' : 'opacity-0'))
                                          }, null, 8, ["class"]),
                                          _createTextVNode(" " + _toDisplayString(manager.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "onSelect"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["open"]),
                _createVNode(_unref(FormMessage))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(Separator), { class: "my-3" }),
      _createVNode(_unref(FormField), { name: "enabled" }, {
        default: _withCtx(({ value, handleChange }) => [
          _createVNode(_unref(FormItem), { class: "flex flex-row items-center gap-4 p-4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(FormLabel), { class: "text-base" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('table.enabled')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_unref(FormControl), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Switch), {
                    checked: value,
                    "onUpdate:checked": handleChange
                  }, null, 8, ["checked", "onUpdate:checked"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }),
      _createVNode(_unref(Separator), { class: "my-3" }),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('building.images')), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_unref(Button), {
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(router).push({ name: 'camera', params: { id: _unref(building).id, entity: 'buildings' }})), ["prevent"])),
          disabled: props.id === '0',
          type: "button",
          class: "w-full text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ImagePlus), { class: "mr-2 h-5 w-5" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_photo')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(Button), {
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'photoRoof', params: { entity:'buildings', id: props.id } })), ["prevent"])),
          disabled: props.id === '0',
          type: "button",
          class: "w-full text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Image), { class: "mr-2 h-5 w-5" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('building.gallery')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createVNode(_unref(Separator), { class: "my-3" }),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t('building.documents')), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_unref(Button), {
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (setIsDocumentDialogOpen(true)), ["prevent"])),
          disabled: props.id === '0',
          type: "button",
          class: "w-full text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FilePlus), { class: "mr-2 h-5 w-5" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_document')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(UploadDocumentDialog, {
          entity: props.entity,
          "entity-id": props.id,
          open: isDocumentDialogOpen.value,
          "set-open": setIsDocumentDialogOpen,
          onEdit: _cache[5] || (_cache[5] = ($event: any) => (setIsDocumentDialogOpen(false)))
        }, null, 8, ["entity", "entity-id", "open"]),
        _createVNode(_unref(Button), {
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'documentsView', params: { entity:'buildings', id: props.id } })), ["prevent"])),
          disabled: props.id === '0',
          type: "button",
          class: "w-full text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(File), { class: "mr-2 h-5 w-5" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('building.document_gallery')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createVNode(_unref(Separator), { class: "my-6" }),
      _createVNode(_unref(Button), {
        type: "submit",
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('table.save')), 1)
        ]),
        _: 1
      })
    ])
  ], 32))
}
}

})